import apiUrls from "../../../config/apiUrls";
import { fetchData } from "../../../services/api";
import IApiResponse from "../../../types/IApiResponse";
import { IValueSeasonGraphChart } from "../../../types/IValueGraphChart";
import handleApiResponse from "../../../utils/handleApiResponse";


export const fetchTransferValueSeasonBenchmark = async (
    setModuleLoading: (value:boolean) => void,
    setTransferValueSeasonData: (data:IValueSeasonGraphChart) => void,
    playerId: number
) => {
    setModuleLoading(true);
    try {
      const response: IApiResponse<IValueSeasonGraphChart> = await fetchData(`${apiUrls["TransferValueSeasonBenchmark"]}?PlayerId=${playerId}`);
      handleApiResponse(
        response,
        (valueData) => {
          setModuleLoading(false);
          setTransferValueSeasonData(valueData);
        },
        (error) => {
          console.error("Error fetching transfer value season data:", error);
        }
      );
    } catch (error) {
      console.error("Error fetching transfer value season benchmark:", error);
    } finally {
      setModuleLoading(false);
    }
  };